.container {
  position: relative;
  width: 100%;
  height: 100%;
}

.canvas {
  background: linear-gradient(135deg, #fffdf7 0%, #fffdf7 100%);
  min-height: 500px;
}

/* Snapshot mirror for Clarity session replay. Sits behind the canvas (DOM
   order), so live users see the WebGL render on top; in Clarity replays the
   canvas is blank and the snapshot shows through. Hidden until the hook
   captures a frame that matches the current view. */
.clarityMirror {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  visibility: hidden;
  pointer-events: none;
}

.staticHint {
  position: absolute;
  left: 50%;
  bottom: 12px;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 92%;
  padding: 8px 12px;
  border-radius: 8px;
  background: rgba(30, 30, 30, 0.82);
  color: #fff;
  font-size: 13px;
  line-height: 1.3;
  text-align: center;
  z-index: 5;
  pointer-events: auto;
}

.staticHintClose {
  flex: none;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #fff;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
}

.staticHintClose:hover {
  background: rgba(255, 255, 255, 0.18);
}

/* Mobile styles for larger canvas */
@media (max-width: 768px) {
  .container {
    min-height: 50vh;
    height: 50vh;
  }

  .canvas {
    min-height: 50vh;
    height: 50vh;
    width: 100%;
  }
}

@media (max-width: 480px) {
  .container {
    min-height: 45vh;
    height: 45vh;
  }

  .canvas {
    min-height: 45vh;
    height: 45vh;
  }
}
